<template>
  <div class="form" :class="{ open: search }">
    <img src="/images/icons/search.svg" alt="" class="search">
    <img src="/images/icons/close-search.svg" alt="" class="close" :class="{ visible: search, invisible: !search }" @click="search = ''">

    <input
      :class="{ open: search }"
      type="text"
      placeholder="Search Habit Health (eg. Auckland, Physiotherapy, Timetable)"
      v-model="search"
      v-debounce:750ms="liveSearch"
      v-on:keyup.enter="enterSearch"
    >
    <div v-show="search" class="dropdown">
      <div v-if="results.length">
        <a :href="link.url" v-for="(link, key) of results" :key="key">
            {{ highlightSearch(link.title) }}
        </a>
      </div>

      <a :href="resultsUrl" class="flex"> <img src="/images/icons/search-dark.svg" alt="">{{ search }}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    search_url: String,
    results_url: String
  },

  data () {
    return {
      search: '',
      payload: {
        keyword: ''
      },
      results: [],
    }
  },
  computed : {
    resultsUrl () {
      return this.results_url + '?keyword=' + this.search
    }
  },

  methods : {
    liveSearch () {
      this.payload.keyword = this.search
      window.axios.post(this.search_url, this.payload)
        .then((response) => {
          this.$store.commit('setLoading', false)

          this.results = response.data.data
        })
        .catch((error) => {
          console.log('prodd error', error)
          this.$store.commit('setLoading', false)
          this.$store.commit('setPopup', {
            content: '<p>Sorry, the search-results could not be loaded.</p>',
            open: true
          })
        })
    },

    highlightSearch (string) {
      let str = string
      // let chunks = this.search.split(' ')
      // console.log(chunks)
      // chunks.forEach(element => {
      //   str = str.replace(element, '<span>' + element + '</span>')
      //   console.log(str)
      // });

      str.replace('Pain', '<span>pain</pain>')

      return str
    },

    enterSearch() {
      if(this.search.length) {
        location.href = this.results_url + '?keyword='+this.search
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/HomeSearch.vue